import instance from '@apis/instance';
import { SliceResponse } from '@models/page';
import {
    GetStampHistoriesParams,
    StampCardSorter,
    StampCardsResponse,
    StampHistoryRow,
} from '@models/stamp';

import {
    mockStampCardsProject, mockStampCardsShop, mockStampCardsShopGroup, mockStampHistories,
} from './mockStampCards';

class StampApi {
    static getStampCards(sorter: StampCardSorter): Promise<StampCardsResponse> {
        return instance.get('/stamp-cards', { params: { sorter } });
        // return Promise.resolve(mockStampCardsProject);
        // return Promise.resolve(mockStampCardsProject);
    }

    static getStampHistories(params: GetStampHistoriesParams): Promise<SliceResponse<StampHistoryRow>> {
        // return Promise.resolve(mockStampHistories(params.page));
        return instance.get('/stamp-card/history', { params });
    }
}

export default StampApi;
